import { ConnectedWallet } from './ConnectedWallet';

export default ConnectedWallet;
